import { render, staticRenderFns } from "./ProfileCreate.vue?vue&type=template&id=0a98e5f0&scoped=true"
import script from "./ProfileCreate.vue?vue&type=script&lang=js"
export * from "./ProfileCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a98e5f0",
  null
  
)

export default component.exports